import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Divider } from 'primereact/divider'

import { LinkButton } from '../../../linkbutton/LinkButton'
import { FooterDialog } from '../../shared'

export const Footer: React.FC = () => {
  const [dialogVisible, setDialogVisible] = useState(false)
  const [header, setHeader] = useState<string | null>(null)
  const [filename, setFilename] = useState<string | null>(null)
  const { t } = useTranslation()

  return (
    <footer className="flex flex-wrap align-content-center justify-content-center md:justify-content-start">
      {filename && (
        <FooterDialog
          visible={dialogVisible}
          setVisible={setDialogVisible}
          header={header}
          filename={filename}
          isLocalfile={true}
        />
      )}

      <small className="text-xs text-gray-300 md:mr-5 text-center mb-1 md:mb-0">
        © {new Date().getFullYear()} {t('login.content.footer.company')}
      </small>

      <small className="text-xs">
        <ul className="pl-0 m-0 list-none">
          <li className="inline-block mr-3">
            <a
              className="text-primary no-underline"
              href="https://nttdata-solutions.com/de/impressum/"
              target="_blank"
              rel="noreferrer"
            >
              {t('login.content.footer.imprint')}
            </a>
          </li>
          <li className="inline-block mr-3">
            <LinkButton
              className="text-primary text-xs"
              onClick={() => {
                setHeader(t('login.content.footer.copyright'))
                setFilename('copyright.md')
                setDialogVisible(true)
              }}
            >
              {t('login.content.footer.copyright')}
            </LinkButton>
          </li>
        </ul>
      </small>
    </footer>
  )
}
